<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex smart-item">
        <v-layout text-right wrap>
          <v-flex pt-2 pb-2 pa-2>
            <v-layout wrap>
              <v-flex xl3 lg3 md3 xs12 class="smart-item-title">
                <span class="display-24">
                  {{ text }}
                  <span class="primary--text">*</span>
                </span>
                <!-- <span
                  v-if="required && !displayedSelections"
                  class="red--text display-14 d-block"
                  >* {{ t(`titles.requiredField`) }}
                </span> -->
              </v-flex>
              <v-divider
                vertical
                class="ml-1"
                v-show="$vuetify.breakpoint.smAndUp"
              />

              <v-flex
                class="display-18 smart-item-fields py-1"
                align-self-center
              >
                {{ selection }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-1 pa-0">
      <v-flex xs12>
        <v-row >
          <v-col md="4" cols="12" class=" my-2">
            <WhatField
              placeholder="חפש תפקיד"
              class="primary--text"
              :keywordJD="keywords"
              @whatSearch="updateKeywordJD"
              @deleteWhat="deleteWhatJD"
            />
          </v-col>
          <v-col md="8" cols="12" v-if="showCategoriesMsg" class="flex-center my-2 ">
            <span class="red--text display-18 ">
              * לאור שינויים שבוצעו באתר - אנא הגדירו מחדש את התפקיד שמעניין אתכם
            </span>
          </v-col>
        </v-row>
      </v-flex>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import WhatField from '@/components/Forms/Form_Fields/WhatField.vue';

export default {
  name: 'SmartAgentFieldExpantionWhatJD',
  components: {
    WhatField,
  },

  props: {
    items: {
      type: Array,
      default: Array,
    },

    text: {
      type: String,
      default: '',
    },

    cautionMsg: {
      type: String,
      default: '',
    },

    showMsgIfLessThen: {
      type: Number,
    },

    // required: {
    //   type: Boolean
    // },
    keywordsJD: {
      type: Array,
      required: false,
    },
    showCategoriesMsg: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      selection: '',
      displayedSelections: null,
      keywords: null,
    };
  },
  computed: {},
  watch: {
    keywords() {
      this.selection = this.keywords ? this.keywords : '';
    },
    selection() {
      this.updateSelections();
    },
  },

  mounted() {
    this.initValues();
  },

  methods: {
    updateSelections() {
      this.$emit('selectionsUpdated', this.selection);
    },
    initValues() {
      if (this.keywordsJD) this.keywords = this.keywordsJD[0];
    },
    updateKeywordJD(value) {
      this.keywords = value;
    },
    deleteWhatJD() {
      this.keywords = '';
    },
  },
};
</script>

<style lang="scss" scoped>
#smart-manager .v-expansion-panel-content__wrap * {
  padding-bottom: 0;
}
.caution {
  color: red;
  align-self: flex-start;
}

.check-item {
  margin: 5px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

@media only screen and (min-width: 960px) {
  .check-item {
    background: #f2f2f2;
    margin: 5px;
    height: 100px;

    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-left: 30px;
  }
}

@media only screen and (min-width: 600px) {
}
</style>
